"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins } from "vue-property-decorator";
import _ from "lodash";
import { AccountSessionMixins } from "@/service/account-session";
import Managerment from "@/views/managements/Managerment.vue";
import MainView from "@/components/layout/MainView.vue";
import UiMenuBar, {
  MenuController
} from "@/components/menu/ManagerMenuBar.vue";
import AccountRecharge from "./components/AccountRecharge.vue";
import InviteGift from "./components/InviteGift.vue";
import CoinLogs from "./components/CoinLogs.vue";
import InvoiceManage from "./components/InvoiceManage.vue";
import OrderManage from "./components/OrderManagement.vue";
import i18n from "@/lang";
let CostManager = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.menu_controller = new MenuController(
      false,
      [
        {
          index: "AccountRecharge",
          icon_image: "expenses_sidebar_1",
          name: i18n.t("cost_management.account_recharge_sidebar")
        },
        {
          index: "InviteMain",
          icon_image: "expenses_sidebar_2",
          name: i18n.t("cost_management.invite_gift_sidebar")
        },
        {
          index: "CoinLogs",
          icon_image: "expenses_sidebar_3",
          name: i18n.t("cost_management.coin_logs_sidebar")
        },
        {
          index: "OrderManage",
          icon_image: "expenses_sidebar_4",
          name: i18n.t("cost_management.order_manage_sidebar")
        },
        {
          index: "InvoiceManage",
          icon_image: "expenses_sidebar_5",
          name: i18n.t("cost_management.invoice_manage_sidebar")
        }
      ],
      "AccountRecharge"
    );
    this.currentGroup = "";
  }
  changeTeamComponent(data) {
    console.log(data);
    if (data) {
      this.currentGroup = data;
    }
  }
  changeCollapse() {
  }
  created() {
    return __async(this, null, function* () {
      this.currentGroup = "AccountRecharge";
    });
  }
  mounted() {
    return __async(this, null, function* () {
      var _a, _b;
      if (this.$session.type === "user" && this.$session.permissions.is("RECHARGE_COIN")) {
        this.menu_controller = new MenuController(
          false,
          [
            {
              index: "AccountRecharge",
              icon_image: "expenses_sidebar_1",
              name: i18n.t("cost_management.account_recharge_sidebar")
            }
          ],
          "AccountRecharge"
        );
        this.currentGroup = "AccountRecharge";
      }
      if (this.$session.type === "user" && this.$session.permissions.is("VIEW_ORDER_DETAIL")) {
        this.menu_controller = new MenuController(
          false,
          [
            {
              index: "OrderManage",
              icon_image: "expenses_sidebar_4",
              name: i18n.t("cost_management.order_manage_sidebar")
            }
          ],
          "OrderManage"
        );
        this.currentGroup = "OrderManage";
      }
      if (this.$session.type === "user" && this.$session.permissions.is("RECHARGE_COIN") && this.$session.permissions.is("VIEW_ORDER_DETAIL")) {
        this.menu_controller = new MenuController(
          false,
          [
            {
              index: "AccountRecharge",
              icon_image: "expenses_sidebar_1",
              name: i18n.t("cost_management.account_recharge_sidebar")
            },
            {
              index: "OrderManage",
              icon_image: "expenses_sidebar_4",
              name: i18n.t("cost_management.order_manage_sidebar")
            }
          ],
          "AccountRecharge"
        );
        this.currentGroup = "AccountRecharge";
      }
      if (this.$session.type === "user" && ((_a = this.$session) == null ? void 0 : _a.permissions.is("SHOW_ALL_MENUS"))) {
        this.menu_controller = new MenuController(
          false,
          [
            {
              index: "AccountRecharge",
              icon_image: "expenses_sidebar_1",
              name: i18n.t("cost_management.account_recharge_sidebar")
            },
            {
              index: "InviteMain",
              icon_image: "expenses_sidebar_2",
              name: i18n.t("cost_management.invite_gift_sidebar")
            },
            {
              index: "CoinLogs",
              icon_image: "expenses_sidebar_3",
              name: i18n.t("cost_management.coin_logs_sidebar")
            },
            {
              index: "OrderManage",
              icon_image: "expenses_sidebar_4",
              name: i18n.t("cost_management.order_manage_sidebar")
            },
            {
              index: "InvoiceManage",
              icon_image: "expenses_sidebar_5",
              name: i18n.t("cost_management.invoice_manage_sidebar")
            }
          ],
          "AccountRecharge"
        );
        this.currentGroup = "AccountRecharge";
      }
      if (this.$session.type === "user" && !((_b = this.$session) == null ? void 0 : _b.permissions.is("RECHARGE_COIN")) && !this.$session.permissions.is("VIEW_ORDER_DETAIL") && !this.$session.permissions.is("SHOW_ALL_MENUS")) {
        this.$router.push("/");
        return;
      }
      if (this.$route.hash) {
        let _hash = this.$route.hash.split("#")[1];
        let _index = _.find(this.menu_controller.menu_lists, { index: _hash });
        if (_index !== void 0) {
          this.menu_controller.default_components = _index.index;
          this.currentGroup = _index.index;
        }
      }
    });
  }
};
CostManager = __decorateClass([
  Component({
    components: {
      Managerment,
      UiMenuBar,
      MainView,
      AccountRecharge,
      InviteGift,
      CoinLogs,
      InvoiceManage,
      OrderManage
    }
  })
], CostManager);
export {
  CostManager as default
};
